import type { ScreeningType } from '@factoryfixinc/ats-interfaces';

// remove minimum
export const MINIMUM_REQUIRED_SCREENER_QUESTIONS = 1;

export const QUESTION_AND_SUGGESTION_CEILING = 7;

/** Edit content is the mutable content used in the form */
export type LocalScreenerQuestion = { text: string; id: number; editContent: string };

/**
 * Adds a virtual type of SKIP that reflects a job with static screening, but no question to ask.
 * This better reflects the form state and is mapped when saving the job.
 */
export type ScreeningTypeWithSkip = ScreeningType | 'SKIP';
